export const enum LoginSupportInteractionEvent {
	Register = "register",
	ForgotPassword = "forgotPassword",
}

export const YEAR_IN_MINUTES = 525600;
export const THIRTY_DAYS_IN_MINUTES = 43200;
